
class HorizontalDivider {
        
    constructor() {
        const templates: HTMLElement = document.querySelector<HTMLElement>('[data-id="templates"]')!;
        const template: HTMLElement = templates.querySelector<HTMLElement>('[data-id="HorizontalDivider"]')!;
        const cloned: HTMLElement = template.cloneNode(true) as HTMLElement;

        const target: HTMLElement = document.querySelector<HTMLElement>('[data-id="zones"] [data-id="content"]')!;

        //target.appendChild(cloned);
        target.insertBefore(cloned, target.firstChild); // reverse visual order
    }
}

export default HorizontalDivider;
